/* ============================================================
   SING WITH AGA — WSPÓLNY SYSTEM JS (v2 — zgodny z sing-* klasami w CSS)
   Jeden plik, linkowany raz. Zastępuje fixShopifyLayout()
   i kopiowane funkcje z każdej podstrony.
   Wymaga, by HTML używał klas/atrybutów opisanych poniżej:
   - .sing-reveal                          → animacja przy scrollu
   - .sing-faq-q (w .sing-faq-item)        → akordeon FAQ
   - .sing-yt-facade[data-vid="ID"]        → facade YouTube
   - .sing-expand-btn (w .sing-expand)     → rozwijane szczegóły kart
   - [data-payu-amount="297"]              → widget rat PayU
   Wszystkie selektory celują wyłącznie w elementy z prefiksem "sing-",
   więc nic wstrzykiwane przez Tevello/PayU/inne appki nie jest dotykane.
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Reveal na scroll ---- */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('sing-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.sing-reveal').forEach(function (el) { revealObserver.observe(el); });

  /* ---- FAQ / akordeon ---- */
  document.querySelectorAll('.sing-faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.sing-faq-item');
      if (!item || !item.parentElement) return;
      var wasOpen = item.classList.contains('sing-open');
      item.parentElement.querySelectorAll('.sing-faq-item.sing-open').forEach(function (i) {
        i.classList.remove('sing-open');
      });
      if (!wasOpen) item.classList.add('sing-open');
    });
  });

  /* ---- Facade wideo YouTube → iframe po kliknięciu ---- */
  document.querySelectorAll('.sing-yt-facade').forEach(function (facade) {
    facade.addEventListener('click', function () {
      var vid = facade.getAttribute('data-vid');
      if (!vid) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + vid + '?autoplay=1&rel=0&modestbranding=1';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      facade.innerHTML = '';
      facade.appendChild(iframe);
      facade.style.cursor = 'default';
      facade.classList.remove('sing-yt-facade');
    });
  });

  /* ---- Rozwijane szczegóły kart ofertowych ---- */
  document.querySelectorAll('.sing-expand-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.sing-expand');
      if (item) item.classList.toggle('open');
    });
  });

  /* ---- Lightbox ze szczegółami produktu ---- */
  var lbOverlay = document.querySelector('.sing-lightbox-overlay');
  var lbBody = lbOverlay && lbOverlay.querySelector('.sing-lightbox-body');
  if (lbOverlay && lbBody) {
    document.querySelectorAll('[data-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return; /* nie otwieraj, jeśli kliknięto realny link/przycisk w karcie */
        var source = document.getElementById(trigger.getAttribute('data-lightbox-trigger'));
        if (!source) return;
        lbBody.innerHTML = source.innerHTML;
        lbOverlay.classList.add('sing-open');
        document.body.style.overflow = 'hidden';
      });
    });
    lbOverlay.addEventListener('click', function (e) {
      if (e.target === lbOverlay || e.target.closest('.sing-lightbox-close')) {
        lbOverlay.classList.remove('sing-open');
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        lbOverlay.classList.remove('sing-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---- Widget rat PayU ---- */
  var payuTargets = document.querySelectorAll('[data-payu-amount]');
  if (payuTargets.length) {
    var payuAttempts = 0;
    var payuMaxAttempts = 20; /* ~6s, potem dajemy spokój, żeby nie mielić w nieskończoność */
    (function tryInit() {
      if (typeof OpenPayU === 'undefined' || typeof OpenPayU.Installments === 'undefined') {
        payuAttempts++;
        if (payuAttempts < payuMaxAttempts) setTimeout(tryInit, 300);
        return;
      }
      payuTargets.forEach(function (el) {
        var amount = parseFloat(el.getAttribute('data-payu-amount'));
        if (!el.id) el.id = 'sing-payu-' + amount + '-' + Math.random().toString(36).slice(2, 7);
        OpenPayU.Installments.miniInstallment('#' + el.id, {
          creditAmount: amount,
          posId: '4420801',
          key: '51',
          showLongDescription: true,
          lang: 'pl',
          currencySign: 'PLN'
        }).then(function (result) {
          if (result.isWidgetAvailable) el.style.display = 'block';
        }).catch(function () { /* widget niedostępny — brak akcji */ });
      });
    })();
  }

});

;(function () {
  /* Black Friday: licznik + kody. Edytujesz tylko obiekt BF. */
  var BF = {
    end: '2026-11-30T23:59:59+01:00',
    p: {
      s:  { id: '56626137891148', code: 'Black4', old: 'taniej300' },
      b3: { id: '57002583785804', code: 'Black6', old: 'promo400' },
      b4: { id: '57002625958220', code: 'Black6', old: 'promo400' }
    }
  };
  var end = new Date(BF.end).getTime(), timer;
  function each(s, fn) { Array.prototype.forEach.call(document.querySelectorAll(s), fn); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function finish() {
    Object.keys(BF.p).forEach(function (k) {
      var o = BF.p[k];
      each('[data-bf-link="' + k + '"]', function (e) { e.href = '/cart/' + o.id + ':1?discount=' + encodeURIComponent(o.old); });
    });
    document.body.classList.add('bf-over');
  }
  function tick() {
    var left = end - Date.now();
    if (left <= 0) { clearInterval(timer); finish(); return; }
    var s = Math.floor(left / 1000);
    var v = { d: Math.floor(s / 86400), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
    each('[data-bf-t]', function (e) { e.textContent = v[e.getAttribute('data-bf-t')]; });
  }
  function start() { if (!document.querySelector('[data-bf-t], [data-bf-link]')) return; if (Date.now() >= end) finish(); else { tick(); timer = setInterval(tick, 1000); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();